/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_TrackedInputs */

const en_items_tracked = /** @type {(inputs: Items_TrackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items Tracked`)
};

const es_items_tracked = /** @type {(inputs: Items_TrackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementos Rastreados`)
};

const fr_items_tracked = /** @type {(inputs: Items_TrackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éléments suivis`)
};

const de_items_tracked = /** @type {(inputs: Items_TrackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgte Elemente`)
};

const id_items_tracked = /** @type {(inputs: Items_TrackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item Dilacak`)
};

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const ja_items_tracked = en_items_tracked;

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const zh_items_tracked = en_items_tracked;

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const ar_items_tracked = en_items_tracked;

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const it_items_tracked = en_items_tracked;

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const ru_items_tracked = en_items_tracked;

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const pt_items_tracked = en_items_tracked;

/** @type {(inputs: Items_TrackedInputs) => LocalizedString} */
const ko_items_tracked = en_items_tracked;

/**
* | output |
* | --- |
* | "Items Tracked" |
*
* @param {Items_TrackedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const items_tracked = /** @type {((inputs?: Items_TrackedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_TrackedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_items_tracked(inputs)
	if (locale === "es") return es_items_tracked(inputs)
	if (locale === "fr") return fr_items_tracked(inputs)
	if (locale === "de") return de_items_tracked(inputs)
	if (locale === "ja") return ja_items_tracked(inputs)
	if (locale === "zh") return zh_items_tracked(inputs)
	if (locale === "ar") return ar_items_tracked(inputs)
	if (locale === "id") return id_items_tracked(inputs)
	if (locale === "it") return it_items_tracked(inputs)
	if (locale === "ru") return ru_items_tracked(inputs)
	if (locale === "pt") return pt_items_tracked(inputs)
	return ko_items_tracked(inputs)
});